export type AudioContainerMode = {
	name: 'expanded' | 'minified';
	width: string;
};

export const AUDIO_CONTAINER_MODES = {
	EXPANDED: {
		name: 'expanded',
		width: '380px',
	},
	MINIFIED: {
		name: 'minified',
		width: '274px',
	},
} as const satisfies Record<string, AudioContainerMode>;
